import BaseFilter, {
  type BaseFilterType,
} from "@search/store/filters/base/BaseFilter";

class BooleanFilter extends BaseFilter {
  constructor({
    defaultValue,
    name = "boolean",
    label = name,
    value,
  }: BaseFilterType) {
    super({ defaultValue, label, name, value: value as boolean });
  }

  get defaultValue() {
    return super.defaultValue as boolean;
  }

  get initialValue() {
    return super.initialValue as boolean;
  }

  get value() {
    return super.value as boolean;
  }
}

export default BooleanFilter;
export { BooleanFilter };
